'use client';

import Image from 'next/image';
import Link from "next/link";

interface Props {
    universityId: number;
    universityName?: string;
    logoUrl: string;
}

export default function UniversityLogoImage({ universityId, universityName, logoUrl }: Props) {
    const url = process.env.PROJECT === "Whatuni" 
        ? `/university-profile/${universityName}/${universityId}`
        : `/universities/${universityName}`;

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
    };

    return (
        <Link href={url} onClick={handleClick}>
            <div className="p-[4px] bg-white rounded-[8px] block shadow-custom-1 min-w-[64px] h-[64px]">
                <Image
                    src={logoUrl}
                    width={64}
                    height={64}
                    className="w-full h-full cursor-pointer"
                    alt="University logo"
                />
            </div>
        </Link>
    );
}
